import cx from 'classnames';

import styles from './ThinkingIndicator.module.css';

/**
 * Assistant-side "working" affordance shown while a turn is in flight but
 * nothing else is animating — between the user's send and the first
 * streamed token, and between a finished tool batch and the next LLM
 * response. Those are the longest silent gaps in a turn (the model is
 * ingesting the prompt or generating a large tool payload), and without
 * this the agent looks dead exactly when it's working hardest.
 *
 * Purely visual: the dots are aria-hidden and screen-reader announcement
 * is handled by MessageList's existing live region, mirroring how the
 * streaming cursor in AssistantMessage stays silent.
 */
export function ThinkingIndicator() {
  return (
    <div
      data-testid="chat-thinking-indicator"
      className="tw-flex tw-items-center tw-gap-4 tw-px-12 tw-py-8"
      aria-hidden="true"
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className={cx(
            'tw-inline-block',
            'tw-h-6',
            'tw-w-6',
            'tw-rounded-full',
            'tw-bg-label-tertiary',
            styles.dot,
          )}
          // Negative delays start each dot mid-cycle so the wave is
          // visible from the first frame instead of after a stagger
          // ramp-up.
          style={{ animationDelay: `${i * 200 - 400}ms` }}
        />
      ))}
    </div>
  );
}
